// Script para ocultar productos addon de búsquedas predictivas
// Se ejecuta después de que los resultados se cargan

// IDs de productos que deben estar ocultos  
const ADDON_HIDDEN_PRODUCT_IDS = [
  '10382273642833', // Cristales Progresivos
  '10384316924241', // Cristales Monofocales  
  '10384328458577', // Cristales de Lectura
  '10384323412305', // Sin Graduar
  '10384435773777', // Progresivos Estándar
  '10384436560209', // Progresivos PRO
  '10384465822033'  // Cristal Fino/Reducido
];

// Función para ocultar productos en búsqueda predictiva
function hideAddonProductsFromSearch() {
  // Buscar todos los elementos con data-product-id
  const productElements = document.querySelectorAll('[data-product-id]');
  
  productElements.forEach(element => {
    const productId = element.getAttribute('data-product-id');
    
    if (productId && ADDON_HIDDEN_PRODUCT_IDS.includes(productId)) {
      // Ocultar elemento completo
      if (element instanceof HTMLElement) {
        element.style.display = 'none';
        element.setAttribute('aria-hidden', 'true');
      }
      
      // También ocultar elementos padre si tienen clases específicas
      const parent = element.closest('.predictive-search-results__card, .product-grid__item, .resource-list__item');
      if (parent && parent instanceof HTMLElement) {
        parent.style.display = 'none';
        parent.setAttribute('aria-hidden', 'true');
      }
    }
  });
}

// Ejecutar al cargar la página
document.addEventListener('DOMContentLoaded', hideAddonProductsFromSearch);

// Ejecutar cuando cambie el DOM (para búsqueda predictiva)
const observer = new MutationObserver(function(mutations) {
  let shouldHide = false;
  
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList') {
      const addedNodes = Array.from(mutation.addedNodes);
      
      // Verificar si se agregaron elementos de productos
      if (addedNodes.some(node => {
        if (node.nodeType === 1 && node instanceof Element) {
          return node.querySelector && node.querySelector('[data-product-id]') ||
                 node.hasAttribute && node.hasAttribute('data-product-id');
        }
        return false;
      })) {
        shouldHide = true;
      }
    }
  });
  
  if (shouldHide) {
    // Pequeño delay para asegurar que el DOM esté completamente actualizado
    setTimeout(hideAddonProductsFromSearch, 50);
  }
});

// Observar cambios en contenedores de búsqueda
const searchContainers = [
  '.predictive-search-results',
  '.product-grid',
  '.search-results',
  '.collection-wrapper',
  '[data-search-results]'
];

searchContainers.forEach(selector => {
  const container = document.querySelector(selector);
  if (container) {
    observer.observe(container, {
      childList: true,
      subtree: true
    });
  }
});

// Addon product hiding system activated silently